import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
	selector: "ic-department-list-item",
	imports: [TranslateModule],
	templateUrl: "./department-list-item.component.html",
	styleUrl: "./department-list-item.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DepartmentListItemComponent {
	/** The name of the department. */
	name = input.required<string>();

	/** Displays a summary of department occupation when provided. */
	isOccupationEmpty = input<boolean>();
}
